// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"mainlayout_mainContent__-cvbt","descriptionS":"mainlayout_descriptionS__1v2yr","descriptionT":"mainlayout_descriptionT__1nR5z"};